export default "__VITE_ASSET__aLlaix82__"